import * as angular from 'angular';

import { BraintreeService } from './braintree.service';

export const braintreeModule = angular.module('braintree', [
])
	.service(BraintreeService.NG1_INJECTION_NAME, BraintreeService)
	.name;
